<section id="grid">
  <gridster [options]="options">
    <gridster-item (window:resize)="resize()" [ngStyle]="{'max-height': maxHeight + 'px'}" [item]="item" *ngFor="let item of dashboard">
      <ndc-dynamic [ndcDynamicComponent]="item.widget"></ndc-dynamic>
    </gridster-item>
  </gridster>
</section>
